import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;

  header.component-header {
    margin-bottom: 1.5em;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      font-size: 1.3rem;
      font-weight: 700;
      color: ${({ theme }) => theme.primary || "#108ee9"};
      margin: 0;
    }

    .header-actions {
      display: flex;
      gap: 1em;
      align-items: center;
    }
  }

  .ant-tabs-nav {
    margin-bottom: 20px;
  }

  .stats-banner {
    display: flex;
    gap: 1.5em;
    margin-bottom: 1.5em;

    .stat-card {
      background: #fff;
      padding: 1.2em 1.5em;
      border-radius: 8px;
      border: 1px solid #f0f0f0;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.3em;

      .stat-title {
        font-size: 0.85rem;
        color: #888;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .stat-number {
        font-size: 1.6rem;
        font-weight: 700;
        color: #222;
      }
    }
  }

  .table-card {
    background: #fff;
    border-radius: 8px;
    padding: 1.5em;
    border: 1px solid #f0f0f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow-x: auto;
    width: 100%;
    max-width: 100%;
  }

  .ant-table-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .action-buttons {
    display: flex;
    gap: 0.5em;
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    header.component-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 1em;

      .header-actions {
        width: 100%;
        button {
          width: 100%;
        }
      }
    }

    .stats-banner {
      flex-direction: column;
      gap: 1em;
    }

    .table-card {
      padding: 1em;
    }
  }
`;
